import React, { useState } from 'react';
import useFetch from 'components/shared/hooks/useFetch';
import Table from 'components/shared/table';
import { routes } from 'constants/config';
import ConversationInteractionPerformanceGraph from './ConversationInteractionPerformanceChartContainer';

const ConversationInteractionPerformance = ({
  scenario,
  groupId,
  question,
}) => {
  const { id: scenarioId } = scenario || question;
  const [{ interactions = [] }, setInteractions] = useState([]);
  const route =
    routes.ON_DEMAND_PRACTICE.CREATOR.CONVERSATIONS.QUESTIONS.INTERACTIONS.METRICS(
      scenario ? scenario.question.id : question.id,
      groupId,
    );
  const { initialLoading } = useFetch(route, setInteractions);

  if (initialLoading) return null;
  const orderedInteractions = interactions.sort(
    (a, b) => a.position - b.position,
  );
  return (
    <>
      <h3 className="ff-ss fw-b ws-pr mt-48 mb-32">
        {t(
          'practice.on_demand_practice.overview.interaction_performance.heading',
        )}
      </h3>
      <ConversationInteractionPerformanceGraph
        interactions={interactions}
        scenarioId={scenarioId}
        groupId={groupId}
        question={scenario ? scenario.question : question}
      />
      <Table
        alternate
        data-test-id={`interactionPerformanceTable-${scenarioId}`}
      >
        <Table.Header className="bg-gray-lightest border-gray-light c-brand-gray-darkest fw-b border-bottom-0 fz-16">
          <Table.HeaderCell size="xs" contentClassName="d-f jc-c">
            {t(
              'practice.on_demand_practice.overview.interaction_performance.number',
            )}
          </Table.HeaderCell>
          <Table.HeaderCell size="xl" center className="border-right-0">
            {t(
              'practice.on_demand_practice.overview.interaction_performance.interaction',
            )}
          </Table.HeaderCell>
          <Table.HeaderCell size="s" contentClassName="d-f jc-c">
            {t(
              'practice.on_demand_practice.overview.interaction_performance.correct',
            )}
          </Table.HeaderCell>
        </Table.Header>
        <Table.Body>
          {orderedInteractions.map(interaction => {
            const { position, subject, percentCorrectOnFirstAttempt, id } =
              interaction;
            return (
              <Table.Row key={id} className="border-0 fz-16">
                <Table.Body.Cell
                  size="xs"
                  className="bg-gray-lightest border-right-1 border-left-0 border-top-0 border-bottom-0 border-right-solid order-gray-light"
                >
                  {position}
                </Table.Body.Cell>
                <Table.Body.Cell size="xl" className="border-0">
                  {subject}
                </Table.Body.Cell>
                <Table.Body.Cell
                  size="s"
                  className="border-0"
                  contentClassName="d-f ai-c"
                >
                  {`${percentCorrectOnFirstAttempt * 100}%`}
                </Table.Body.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </>
  );
};

export default ConversationInteractionPerformance;
